export enum Status {
    PENDING = "pending",
    APPROVED = "approved",
    // REJECTED = "rejected",
    FROZEN = "frozen",
    REJECTED = "rejected",
}

export enum TransactionStatus {
    PENDING = "pending",
    COMPLETED = "completed",
    FROZEN = "frozen",
    DECLINED = "declined",
    APPROVED = "approved",
}

export enum GeneralStatus {
    UNINITIATED = "uninitiated",
    PENDING = "pending",
    APPROVED = "approved",
    REJECTED = "rejected",
}

export type GeneralStatusRequest = {
    [key in keyof typeof GeneralStatus]: keyof typeof GeneralStatus;
}

export type StatusRequest = {
    [key in keyof typeof Status]: keyof typeof Status;
}

export type TransactionStatusRequest = (typeof TransactionStatus[keyof typeof TransactionStatus])

